import { useEffect, useState, useCallback, useMemo } from 'react'
import {
   Breadcrumb,
   Button,
   Card,
   Col,
   DatePicker,
   Divider,
   Input,
   Pagination,
   Row,
   Table,
   Tooltip,
   Typography
} from 'antd'
import {
   HomeOutlined,
   PlusCircleOutlined,
   ExclamationCircleOutlined,
   CheckOutlined,
   InfoCircleOutlined,
   DeleteOutlined
} from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import locale from 'antd/es/date-picker/locale/vi_VN'
import { isEmpty, trim } from 'lodash'

import { useStore } from '../../hooks'
import {
   DATE_FORMAT_CLIENT,
   DATE_FORMAT_CLIENT_PARAMS,
   DATE_TIME_FORMAT_CLIENT,
   PAGE_SIZE,
   typeFund,
   statusFund,
   getRoleName
} from '../../helpers/constants'
import { formatCurrency } from 'src/helpers/functions'
import { getPage, getStatusThuChi, getTypeThuChi } from 'src/helpers/constants'
import useModal from 'src/helpers/modal/useModal'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { ROUTER_PATH } from '../routes/metaData'

const { Title } = Typography
const { RangePicker } = DatePicker

const FundScreen = observer(() => {
   const { t } = useTranslation()
   const history = useHistory()
   const { confirm } = useModal()
   const FundStore = useStore('FundStore')

   const [textSearch, set_textSearch] = useState('')
   const [startTime, setStartTime] = useState(moment().subtract(1, 'months'))
   const [endTime, setEndTime] = useState(moment())
   const [formSearch, setFormSearch] = useState<any>({})

   const { rows, offset, count } = FundStore.fundList
   const { before, collect, spend, after } = FundStore.priceFund

   // useEffect(() => {
   //    fetchData()
   //    // eslint-disable-next-line react-hooks/exhaustive-deps
   // }, [formSearch, startTime, endTime])

   // const fetchData = async () => {
   //    const params = {
   //       offset: 0,
   //       text: trim(formSearch.search || ''),
   //       from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS),
   //       to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS)
   //    }
   //    await FundStore.getFundList(params)
   //    await FundStore.getTotalPrice(params.from, params.to)
   // }

   // const onChangePage = (page: number) => {
   //    const params = {
   //       offset: getPage(page - 1),
   //       text: trim(formSearch.search || ''),
   //       from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS),
   //       to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS)
   //    }
   //    FundStore.getFundList(params)
   // }

   useEffect(() => {
      getListData(0, {
         text: trim(textSearch),
         from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
      })
      FundStore.getTotalPrice(
         moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
      )
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch, startTime, endTime])

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage)
         const params = { offset, ...param }
         //  console.log('params', params)

         await FundStore.getFundList(params)
      } catch (error) {
         //  console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }

   const onChange = (currentPage: number) => {
      getListData(currentPage - 1, { text: trim(textSearch) })
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }
   const handleRangePickerChange = (date: any) => {
      // set_dateRangerPicker(date);
      //  console.log('datee: ', date)
      setStartTime(date[0])
      setEndTime(date[1])
   }

   const handleConfirm = (record: any) => {
      confirm({
         title: t('banchapnhanphieuyeucaunay'),
         icon: <ExclamationCircleOutlined />,
         okText: t('agree'),
         cancelText: t('cancel'),
         async onOk() {
            console.log('record', JSON.stringify(record))

            await FundStore.approveFund(record?.id, { reject: false })
            getListData(0, {
               text: trim(textSearch),
               from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
               to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
            })
         }
      })
   }

   const handleReject = (record: any) => {
      confirm({
         title: t('bantuchoiphieuyeucaunay'),
         icon: <ExclamationCircleOutlined />,
         okText: t('agree'),
         cancelText: t('cancel'),
         async onOk() {
            await FundStore.approveFund(record?.id, { reject: true })
            getListData(0, {
               text: trim(textSearch),
               from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
               to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
            })
         }
      })
   }

   const handleRedirectToCreate = useCallback(() => {
      history.push(`/${ROUTER_PATH.FundCreateScreen}`)
   }, [history])

   const showDetail = useCallback(
      (detail: any) => {
         FundStore.setFundSelected(detail)
         history.push(`/${ROUTER_PATH.FundDetailScreen.replace(':id', detail?.id?.toString())}`)
      },
      [history]
   )

   const showEdit = useCallback(
      (detail: any) => {
         history.push(`/${ROUTER_PATH.FundUpdateScreen.replace(':id', detail?.id?.toString())}`)
      },
      [history]
   )
   const columns = useMemo(
      () => [
         { title: 'ID', dataIndex: 'id', key: 'id' },
         { title: 'Mã phiếu', dataIndex: 'code', key: 'code', width: 120 },
         {
            title: t(GLOBAL_CLIENT.type),
            dataIndex: 'type',
            key: 'type',
            render: (val: any) => getTypeThuChi(val)
         },
         {
            title: 'Ngày tạo',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (val: string) => moment(val).format(DATE_TIME_FORMAT_CLIENT)
         },
         {
            title: 'Người nhập/nộp',
            dataIndex: 'account',
            key: 'account',
            render: (val: any) => (val?.name ? `${val?.name}『${getRoleName(val?.role)}』` : '')
         },
         {
            title: 'Tiền vào',
            key: 'moneyIn',
            render: (_: any, record: any) =>
               record?.type === typeFund.COLLECT || record?.type === typeFund.RECHARGE
                  ? '+' + formatCurrency(record?.price, true) + ' P'
                  : ''
         },
         {
            title: 'Tiền ra',
            key: 'moneyOut',
            render: (_: any, record: any) =>
               record?.type === typeFund.SPEND || record?.type === typeFund.WITHDRAW
                  ? '-' + formatCurrency(record?.price, true) + ' P'
                  : ''
         },
         {
            title: t(GLOBAL_CLIENT.status),
            dataIndex: 'status',
            key: 'status',
            render: (val: any) => getStatusThuChi(val)
         },
         {
            title: t('actions'),
            key: 'action',
            align: 'center' as 'center',
            width: 120,
            fixed: 'right' as 'right',
            render: (record: any) =>
               record?.status === statusFund.NEW ? (
                  <span>
                     <span onClick={() => showDetail(record)} className="gx-link">
                        <Tooltip placement="top" title={'Chi tiết'}>
                           <InfoCircleOutlined />
                        </Tooltip>
                     </span>
                     <Divider type="vertical" />
                     <span onClick={() => handleConfirm(record)} className="gx-link">
                        <Tooltip placement="top" title={'Xác nhận'}>
                           <CheckOutlined />
                        </Tooltip>
                     </span>
                     <Divider type="vertical" />
                     <span onClick={() => handleReject(record)} className="gx-link" style={{ color: 'red' }}>
                        <Tooltip placement="top" title={'Từ chối'}>
                           <DeleteOutlined />
                        </Tooltip>
                     </span>
                  </span>
               ) : (
                  <span onClick={() => showDetail(record)} className="gx-link">
                     <Tooltip placement="top" title={'Chi tiết'}>
                        <InfoCircleOutlined />
                     </Tooltip>
                  </span>
               )
         }
      ],
      [t]
   )
   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }
   return (
      <div>
         {/* Header */}
         <Row style={{ padding: '0 20px' }} className="gx-justify-content-between gx-align-items-center">
            <Col>
               <Title level={4}>{'Quản lý quỹ'}</Title>
               <Breadcrumb>
                  <Breadcrumb.Item href="/">
                     <HomeOutlined className="gx-link" />
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{'Admin'}</Breadcrumb.Item>
                  <Breadcrumb.Item className="gx-link">{'Quản lý quỹ'}</Breadcrumb.Item>
               </Breadcrumb>
            </Col>
            <Col>
               <Button icon={<PlusCircleOutlined />} type="primary" onClick={handleRedirectToCreate}>
                  {t('add_new')}
               </Button>
            </Col>
         </Row>

         {/* Card chứa filter + table */}
         <Card style={{ marginTop: 20 }}>
            <Row gutter={16}>
               <Col span={8}>
                  <Input.Search placeholder={t('search')} allowClear onSearch={handleChangeTextSearch} />
               </Col>
               <Col span={8}>
                  <RangePicker
                     allowClear={false}
                     defaultValue={[startTime, endTime]}
                     format={DATE_FORMAT_CLIENT}
                     locale={locale}
                     onChange={handleRangePickerChange}
                     // onChange={(dates) => {
                     //    setStartTime(dates?.[0] || moment().subtract(1, 'months'))
                     //    setEndTime(dates?.[1] || moment())
                     // }}
                  />
               </Col>
            </Row>

            {/* Summary */}
            <Row
               className="row-container-head"
               style={{ background: '#919eab16', padding: 12, borderRadius: 6, marginLeft: 0, marginRight: 0 }}
            >
               <Col span={4}>
                  <Col>
                     <span style={{ fontWeight: 'bold' }}>Số dư đầu kỳ</span>
                  </Col>
                  <Col>
                     <span style={{ fontSize: 18, color: '#6998B9', fontWeight: 'bolder' }}>
                        {formatCurrency(before, true)}
                     </span>
                  </Col>
               </Col>
               <Col span={1} style={{ alignSelf: 'center' }}>
                  {/* <span style={{ fontWeight: 'bolder' }}>+</span> */}
               </Col>
               <Col span={4}>
                  <Col>
                     <span style={{ fontWeight: 'bold' }}>Tổng thu</span>
                  </Col>
                  <Col>
                     <span style={{ fontSize: 18, color: '#89AD88', fontWeight: 'bolder' }}>
                        {formatCurrency(collect, true)}
                     </span>
                  </Col>
               </Col>
               <Col span={1} style={{ alignSelf: 'center' }}>
                  {/* <span style={{ fontWeight: 'bolder' }}>-</span> */}
               </Col>
               <Col span={4}>
                  <Col>
                     <span style={{ fontWeight: 'bold' }}>Tổng chi</span>
                  </Col>
                  <Col>
                     <span style={{ fontSize: 18, color: '#B87986', fontWeight: 'bolder' }}>
                        {formatCurrency(spend, true)}
                     </span>
                  </Col>
               </Col>
               <Col span={1} style={{ alignSelf: 'center' }}>
                  {/* <span style={{ fontWeight: 'bolder' }}>=</span> */}
               </Col>
               <Col span={4}>
                  <Col>
                     <span style={{ fontWeight: 'bold' }}>Tồn cuối kỳ</span>
                  </Col>
                  <Col>
                     <span style={{ fontSize: 18, color: '#3F74A1', fontWeight: 'bolder' }}>
                        {formatCurrency(after, true)}
                     </span>
                  </Col>
               </Col>
            </Row>

            {/* Table */}
            <Table style={{ marginTop: 20 }} columns={columns} dataSource={rows} rowKey="id" pagination={false} />

            {renderPagination()}
         </Card>
      </div>
   )
})

export default FundScreen
